import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";

import * as S from "./styles";
import FarmHeader from "../../components/nova-farm/farm-header";
import LastRecipes from "../../components/last-recipes";
import CalendaryNovaFarm from "../../components/nova-farm/calendary-nova-farm";
import ViewMap from "../../components/novo-produtores/mapView";
import FarmCropManagement from "../../components/nova-farm/farm-crop-management";
import DolarGraphic from "../../components/nova-farm/dolar-graphic";
import RainForecastGraphic from "../../components/nova-farm/rain-forecast-graphic";
import QuotationGraphic from "../../components/nova-farm/quotation-cultures";
import GraphicPreview from "../../components/GraphicPreview";
import WeatherTrafficLight from "../../components/nova-farm/weather-traffic-light";

import HeaderV2 from "../../components/headerV2";
import Recipe from "../../components/nova-home/recipe";
import api from "../../services/api";
import NewCardNotificationFarm from "../../components/nova-farm/card-notification";
import FunctionBlockedOverlay from "../../components/functionBlocked";
import Modal from "../../components/modal/modalFuncaoBloqueadaImpressaoFe";
import { WEATHER_API_KEY } from "../../services/apiKeys";

export const compendioG = "@compendioG";
const USER = JSON.parse(localStorage.getItem("@userinfo"));

const isFunctionBlocked = (user) => {
  const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
  const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
  return (
    planId === 7 ||
    planId === 6 ||
    planId === 4 ||
    (planId === 1 && diasRestante <= 0)
  );
};

const NovaFarm = ({ ...props }) => {
  const [allRecipes, setAllRecipes] = useState([]);
  const [coordenadas, setCoordenadas] = useState({
    latitude: "",
    longitude: "",
  });
  const [farmId, setFarmId] = useState(0);
  const [farm, setFarm] = useState({ nome: "" });
  const [culturas, setCulturas] = useState([]);
  const [culturaId, setCulturaId] = useState("");
  const [culturaNome, setCulturaNome] = useState("");
  const [openModalTrue, setOpenModalTrue] = useState(false);
  const [weatherData, setWeatherData] = useState(null);
  // true só quando a busca do clima falhou de verdade (erro de rede/API) -
  // distinto de "ainda carregando" (weatherData null) e de "carregou mas
  // sem previsão útil" (weatherData.list vazio), que o semáforo trata à parte.
  const [weatherError, setWeatherError] = useState(false);

  const weatherMapBlockedRef = useRef(null);
  const mapViewBlockedRef = useRef(null);
  const cropManagementBlockedRef = useRef(null);
  const quotationDolarRef = useRef(null);

  const isBlocked = isFunctionBlocked(USER);

  // Mesmo formato de endereço usado em farm-header/index.js (geocodificação) -
  // só os pedaços que a fazenda realmente tiver preenchido.
  const farmAddress = [farm.endereco, farm.numero, farm.complemento, farm.bairro, farm.cidade]
    .filter(Boolean)
    .join(", ");


  const getAllRecipes = async () => {
    try {
      const response = await api.get(
        `/receitas/historico/fazenda/${farmId}/${
          culturaId || "*"
        }?limit=4&offset=0`
      );
      setAllRecipes(response.data.data);
      setCulturas(response.data.culturas);
    } catch (error) {
    }
  };

  const getFarmById = async (idFarm) => {
    try {
      const response = await api.get(`/fazendas/${idFarm}`);
      //como padrão ele irá trazer sempre a primeira cultura da fazenda.
      setCulturaNome(response.data.data.cultura[0].nome_comum);
    } catch (error) {
    }
  };

  useEffect(() => {
    if (farmId) {
      getAllRecipes();
    }
  }, [farmId]);

  useEffect(() => {
    if (farmId && culturaId) {
      getAllRecipes();

      culturas.map((c) => {
        if (c.value === parseInt(culturaId)) {
          setCulturaNome(c.label);
        }
      });
    }
  }, [farmId, culturaId]);

  useEffect(() => {
    //Se o usuário ainda não tiver emitido receita, o sistema deverá pegar a cultura setada inicialmente na fazenda (usuários de teste grátis)
    if (culturaNome === "") {
      getFarmById(farmId);
    }
  }, [culturaNome, farmId]);

  useEffect(() => {
    if (props.match.params.idfazenda) {
      setFarmId(props.match.params.idfazenda);
    }
  }, [props]);

  useEffect(() => {
    const fetchWeather = async () => {
      // A grade do semáforo mostra as coordenadas da fazenda - a previsão usada
      // precisa ser da mesma fonte, senão o usuário vê "-15.67, -47.82" no
      // cabeçalho mas uma previsão buscada só pelo nome da cidade (que pode
      // divergir bastante da fazenda real, especialmente em cidades grandes
      // ou com coordenadas mais precisas que o centro da cidade).
      // Coordenada é opcional no cadastro da fazenda (ver fazendas.service.ts) -
      // sem ela, cai de volta pra busca por nome de cidade, como já era antes.
      const lat = coordenadas?.latitude;
      const lon = coordenadas?.longitude;
      const temCoordenadas = lat !== "" && lat != null && lon !== "" && lon != null;

      if (!temCoordenadas && !farm.cidade) return;

      const query = temCoordenadas
        ? `lat=${lat}&lon=${lon}`
        : `q=${farm.cidade}`;

      setWeatherError(false);

      try {
        const response = await axios.get(
          `https://api.openweathermap.org/data/2.5/forecast?${query}&units=metric&lang=pt&appid=${WEATHER_API_KEY}`
        );
        setWeatherData(response.data);
      } catch (error) {
        console.error("Erro ao buscar dados do clima (NovaFarm):", error);
        setWeatherData(null);
        setWeatherError(true);
      }
    };

    fetchWeather();
  }, [farm.cidade, coordenadas?.latitude, coordenadas?.longitude]);

  return (
    <S.Container>
      <S.Wrapper>
        <HeaderV2 name={farm.nome} title={farm.nome} />

        <FarmHeader
          updateCoordinates={(e) => setCoordenadas(e)}
          updateFarm={(e) => setFarm(e)}
          setFarmId={farmId}
        />

        <NewCardNotificationFarm farmId={farmId} />
        {allRecipes.length === 0 ? (
          <Recipe maxWidth="1074px" />
        ) : (
          <LastRecipes
            allRecipes={allRecipes}
            culturas={culturas}
            updateCultura={(e) => setCulturaId(e)}
            maxWidth="1074px"
          />
        )}

        <S.MainContainers>
          <S.PrimaryContainer>
              {/* <CalendaryNovaFarm
                codIBGE={farm.cod_ibge}
                location={farm.cidade}
                /> */}

            <S.Background ref={weatherMapBlockedRef}>
              {/* Previsão semanal - o semáforo climático entra logo abaixo dos
                  cards de condições climáticas (via prop afterDailyCards),
                  antes dos gráficos de temperatura/chuva */}
              <GraphicPreview
                coordenadas={coordenadas}
                codIBGE={farm.cod_ibge}
                location={farm.cidade}
                address={farmAddress}
                weatherData={weatherData}
                afterDailyCards={
                  <WeatherTrafficLight
                    weatherData={weatherData}
                    weatherError={weatherError}
                    fazendaId={farmId}
                  />
                }
              />
            </S.Background>

              {isBlocked && (
                <FunctionBlockedOverlay
                  visible
                  mode="cover-parent"
                  attachTo={weatherMapBlockedRef}
                  ctaType="activate"
                  onActivate={() => setOpenModalTrue(true)}
                />
              )}
          </S.PrimaryContainer>

          <S.SecondContainer>
            <S.ContainerFarmCropManagement  ref={cropManagementBlockedRef}>
              <FarmCropManagement farmId={farmId} />
            </S.ContainerFarmCropManagement>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={cropManagementBlockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}

            {/* Mapa do meteoblue, logo abaixo do Caderno de Campo */}
            <S.MapView ref={mapViewBlockedRef}>
              <ViewMap coordenadas={coordenadas} />
            </S.MapView>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={mapViewBlockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}

            <S.ContainerDolarAndQuotation ref={quotationDolarRef}>
              <QuotationGraphic farmId={farmId} overlayMode="none" />

              <DolarGraphic overlayMode="none" />
            </S.ContainerDolarAndQuotation>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={quotationDolarRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}
          </S.SecondContainer>
        </S.MainContainers>
      </S.Wrapper>

      {openModalTrue ? (
        <Modal show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
      ) : null}
    </S.Container>
  );
};

export default withRouter(NovaFarm);